/* eslint-disable */
// https://dev2.bhsn.it/api/mtm/swagger-ui/index.html
import type { AxiosPromise, AxiosInstance } from 'axios';
import { toAxiosOptions, mergeObjects } from '@allibee/utils';

let axiosInstance: AxiosInstance;
let baseURL: string;

const serviceRoute = 'mtm';
export function setupServiceInstance(callback: (serviceRoute: string) => { baseURL: string; instance: AxiosInstance }) {
    const result = callback(serviceRoute);
    axiosInstance = result.instance;
    baseURL = result.baseURL;
}

export function getBaseURL() {
    return baseURL;
}

/**
 * 워크스페이스 삭제 요청 정보 조회하기 V1
 * @returns MtmLissResponseWorkspaceDeletionRequestDto OK
 * @throws ApiError
 */
export function getCurrentWorkspaceDeletionRequest(_?: any, requestConfig?: RequestConfig): AxiosPromise<MtmLissResponseWorkspaceDeletionRequestDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-deletion-requests/current/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 삭제 요청 철회하기 V1
 * @returns MtmLissResponse OK
 * @throws ApiError
 */
export function withdrawCurrentWorkspaceDeletionRequest(_?: any, requestConfig?: RequestConfig): AxiosPromise<MtmLissResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'DELETE',
                url: '/workspace-deletion-requests/current/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 정보 조회하기 V1
 * @returns MtmLissResponseWorkspaceForDeletionDto OK
 * @throws ApiError
 */
export function getCurrentWorkspaceForDeletion(_?: any, requestConfig?: RequestConfig): AxiosPromise<MtmLissResponseWorkspaceForDeletionDto> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'GET',
                url: '/workspace-deletion-requests/current-workspace/v1',
            }),
            requestConfig,
        ),
    );
}
/**
 * 워크스페이스 삭제 요청하기 V1
 * @returns MtmLissResponse OK
 * @throws ApiError
 */
export function requestDeletion(
    {
        requestBody,
    }: {
        requestBody: MtmWorkspaceDeletionRequestForm;
    } = {} as any,
    requestConfig?: RequestConfig,
): AxiosPromise<MtmLissResponse> {
    return axiosInstance(
        mergeObjects(
            toAxiosOptions({
                method: 'POST',
                url: '/workspace-deletion-requests/v1',
                body: requestBody,
                mediaType: 'application/json',
            }),
            requestConfig,
        ),
    );
}
